import { useState, useLayoutEffect } from 'react'
import { useMediaQuery } from 'react-responsive'

function useResponsive() {

  const [isClient, setIsClient] = useState(false)

  // Bulma sizes
  const isFullhd = useMediaQuery({
    query: '(min-width: 1408px)'
  })

  const isWidescreen = useMediaQuery({
    query: '(min-width: 1216px)'
  })

  const isDesktop = useMediaQuery({
    query: 'screen and (min-width: 1024px)'
  })

  const isTablet = useMediaQuery({
    query: 'screen and (min-width: 769px)'
  })

  const isSmallTablet = useMediaQuery({
    query: 'screen and (min-width: 576px)'
  })

  const untilWidescreen = useMediaQuery({
    query: 'screen and (max-width: 1215px)'
  })
  
  const isMobile = useMediaQuery({
    query: 'screen and (max-width: 768px)'
  })

  // Custom sizes
  const isMobileText = useMediaQuery({
    query: 'screen and (max-width: 959px)'
  })
  
  const isMobileAccordion = useMediaQuery({
    query: 'screen and (max-width: 579px)'
  })

  const isMobileMenu = useMediaQuery({
    query: 'screen and (max-width: 519px)'
  })

  useLayoutEffect(() => {
    if (typeof window !== 'undefined')
      setIsClient(true)
  }, [])

  return {
    isFullhd: isClient ? isFullhd : true,
    isWidescreen: isClient ? isWidescreen : false,
    isDesktop: isClient ? isDesktop : false,
    isTablet: isClient ? isTablet : false,
    isSmallTablet: isClient ? isSmallTablet : false,
    isMobile: isClient ? isMobile : false,
    untilWidescreen: isClient ? untilWidescreen : false,
    isMobileText: isClient ? isMobileText : false,
    isMobileAccordion: isClient ? isMobileAccordion : false,
    isMobileMenu: isClient ? isMobileMenu : false,
    isReady: isClient,
  }
}

export default useResponsive
